{
  "Clear search": "Απαλοιφή αναζήτησης"
}